/**
 * Show a small message bar below the header. User can close it and it will not be shown again.
 * State is stored in local storage. s
 */
export default class MessageBar {
  constructor(element) {
    this.dom = {
      element: element,
      closeButton: element.querySelector('button.close')
    }
 
    this.addEventListeners();
  }

  show() {    
    if (this.isOpen()) {
      this.dom.element.classList.remove('d-none');
    }    
  }

  _localStorageKey() {
    return `messagebar-${this.dom.element.dataset.pid}`;
  }

  isOpen() {    
    return !window.localStorage.getItem(this._localStorageKey());    
  }

  close() {
    window.localStorage.setItem(this._localStorageKey(), true);
    this.dom.element.classList.add('d-none');
  }

  addEventListeners() {
    this.dom.closeButton.addEventListener('click', this.close.bind(this));
  }

  static init() {
    const messageBars = document.querySelectorAll('.messagebar');
    messageBars.forEach((element) => {
      new MessageBar(element).show();
    });
  }
}